import axios from 'axios';
import * as React from 'react';
import { requestUpdateApTemplateAction } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { UpdateApTemplateActionRequest } from '../sic-lib/types/ApTemplateAction';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncModifyApTemplateAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestUpdateApTemplateAction HTTP request
 */
export default function useAsyncModifyApTemplateAction() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncModifyApTemplateAction = async (
        templateId: number,
        actionId: number,
        updateObj: UpdateApTemplateActionRequest,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.none);

            await requestUpdateApTemplateAction(
                templateId,
                actionId,
                updateObj,
                request_token.token,
            );

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while creating Action Plan action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncModifyApTemplateAction,
    };
}
